const LangChangePassword = {
	"changePassword._title": ["CHANGE PASSWORD", "ប្តូរ​លេខ​សម្ងាត់"],
	"changePassword.form.label._currentPassword": [
		"Current Password",
		"លេខ​សម្ងាត់​ចាស់",
	],
	"changePassword.form.label._newPassword": ["New Password", "លេខ​សម្ងាត់​ថ្មី"],
	"changePassword.form.label._confirmNewPassword": [
		"Confirm New Password",
		"បញ្ជាក់​លេខ​សម្ងាត់​ថ្មី",
	],
}

export default LangChangePassword



// WEBPACK FOOTER //
// ./src/resources/pages/LangChangePassword.js